import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SimpleEntity } from '../../models/simple-entity.model';
import { WhStockWarehouse } from '../../models/warehouse/whstock-warehouse.model';
import { BaseService } from '../base.service';


@Injectable()
export class WarehouseService extends BaseService<any>{
    constructor(public httpClient: HttpClient) {
        super(
            'werehouse',
            httpClient);
    }

    autocomplete = this.getMyWarehouse;

    getMyWhStockWarehouse(): Observable<WhStockWarehouse[]> {

        var url = environment.baseUrl + "/warehouse/getMyWhStockWarehouse";

        return this.httpClient.get<WhStockWarehouse[]>(url, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    getMyWarehouse(): Observable<SimpleEntity[]> {

        var url = environment.baseUrl + "/warehouse/getMyWarehouse";

        return this.httpClient.get<SimpleEntity[]>(url, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }
}
